import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";
import { getAgencies } from "common/services/agencies.service";
import { normalize } from "common/lib/normalize";

const SelectAgency = ({
  validation,
  label,
  index,
}: {
  validation: any;
  label?: any;
  index: number;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.performanceRatings?.[index]?.agency &&
        validation.errors.performanceRatings?.[index]?.agency
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.performanceRatings?.[index]?.agency &&
          validation.errors.performanceRatings?.[index]?.agency
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      try {
        setLoading(true);
        const agencies = await getCachedAgencyOptions();
        if (mounted) setData(agencies);
      } catch (error) {
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label
        htmlFor={`performanceRatings[${index}].agency`}
        className="form-label"
      >
        {label ? label : "Agency"}
      </Label>
      <Select
        name={`performanceRatings[${index}].agency`}
        id={`performanceRatings[${index}].agency`}
        value={
          validation.values.performanceRatings[index]?.agency?.value
            ? validation.values.performanceRatings[index]?.agency
            : null
        }
        placeholder="Select agency"
        onChange={(value: any) => {
          validation.setFieldValue(
            `performanceRatings[${index}].agency`,
            value
          );
        }}
        options={options}
        onBlur={() =>
          validation.setFieldTouched(
            `performanceRatings[${index}].agency`,
            true
          )
        }
        className={
          validation.touched.performanceRatings?.[index]?.agency &&
          validation.errors.performanceRatings?.[index]?.agency
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>
        {validation.errors.performanceRatings?.[index]?.agency?.value}
      </FormFeedback>
    </FormGroup>
  );
};

let cachedAgencies: any[] | null = null;
let agencyOptionsRequest: Promise<any[]> | null = null;

const getCachedAgencyOptions = async () => {
  if (cachedAgencies) return cachedAgencies;

  if (!agencyOptionsRequest) {
    agencyOptionsRequest = getAgencies({
      pagination: {
        page: 1,
        pageSize: 10000,
      },
      filters: {
        category: {
          $null: false,
        },
      },
    }).then((response: any) => {
      cachedAgencies = normalize(response.data);
      return cachedAgencies || [];
    });
  }

  return agencyOptionsRequest;
};

export default SelectAgency;
